import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import CustomerSettingsForm from './CustomerSettingsForm';
import i18n from 'i18n';

interface CustomerSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeCustomerId: number;
}

const CustomerSettingsModal: React.FC<CustomerSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeCustomerId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_customer_settings.text')}
        entityId={activeCustomerId}
        entityIdPropName="customerId"
        FormComponent={CustomerSettingsForm}
    />
));

export default CustomerSettingsModal; 